import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { rmPincodeService } from '@/services/rmPincode.service';
import { QUERY_KEYS } from '@/utils/constants';

export const useRmPincodes = () =>
  useQuery({
    queryKey: QUERY_KEYS.ADMIN.RM_PINCODES,
    queryFn: rmPincodeService.list,
  });

export const useReplaceRmPincodes = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ userId, pincodes }: { userId: number; pincodes: string[] }) =>
      rmPincodeService.replace(userId, pincodes),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: QUERY_KEYS.ADMIN.RM_PINCODES }),
  });
};
